// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popover-wrapper {
  position: relative;
  height: 100%;
  width: 100%;
}

.popover-content {
  position: absolute;
  opacity: 1;
  z-index: 100;
  height: 100%;
  min-width: 100%;
  overflow: visible;
  overflow: initial;
}
.popover-content.popover-hidden {
  overflow: hidden;
  opacity: 0;
  width: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/Popover/index.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;AACF;;AAEA;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EAAA,iBAAA;AACF;AAAE;EACE,gBAAA;EACA,UAAA;EACA,QAAA;AAEJ","sourcesContent":[".popover-wrapper {\n  position: relative;\n  height: 100%;\n  width: 100%;\n}\n\n.popover-content {\n  position: absolute;\n  opacity: 1;\n  z-index: 100;\n  height: 100%;\n  min-width: 100%;\n  overflow: unset;\n  &.popover-hidden {\n    overflow: hidden;\n    opacity: 0;\n    width: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
